
import { defineComponent } from 'vue'
import { mapActions } from 'vuex'
import { OrgGroupsActions } from '~/store/control-panel/groups'
import { EnterpriseGroup } from '~/types/types'

export default defineComponent({
  name: 'ControlPanelEditGroupModal',

  props: {
    group: {
      type: Object as () => EnterpriseGroup,
      required: true
    }
  },

  data() {
    return {
      editingGroup: false,
      showEditGroupModal: false,
      groupName: ''
    }
  },

  watch: {
    'group.name': {
      immediate: true,
      handler(newGroupName: string) {
        this.groupName = newGroupName
      }
    }
  },

  methods: {
    ...mapActions('control-panel/groups', {
      updateOrgGroup: OrgGroupsActions.UPDATE_GROUP
    }),

    showModal(): void {
      this.showEditGroupModal = true
    },

    async editGroup(close: () => void): Promise<void> {
      this.editingGroup = true
      const response = await this.updateOrgGroup({
        groupId: this.group.id,
        groupName: this.groupName
      })
      if (response) {
        this.$emit('refetch')
        this.$toast.success('Group created successfully.')
        if (close) close()
      } else {
        this.$toast.danger('An error occured while deleting group, please try again.')
      }
      this.editingGroup = false
    }
  }
})
